const THREE = require('three')
export const blue = new THREE.Color(0x0011FF)
export const red = new THREE.Color(0xEB0033)
export const white = new THREE.Color(0xFFFFFF)


// WEBPACK FOOTER //
// ./src/components/game/colors.js